import { combineReducers } from "@reduxjs/toolkit";
import gstReducer from '../redux/slices/gstSlice';
import authReducer from '../redux/slices/authSlice'; 
import otpReducer from "../redux/slices/authSlice";
import pincodeReducer from "../redux/slices/pincodeSlice";
import memberReducer from '../redux/slices/pincodeSlice';
import businessReducer  from "../redux/slices/businessSlice";
import uploadReducer from '../redux/slices/uploadSlice';
import loginReducer from '../redux/slices/loginSlice';
import businessDataReducer from '../redux/slices/memberbusinessSlice'; 
import memberVerifyReducer from '../redux/slices/memberVerifySlice';
import changePartnerStatusReducer from '../redux/slices/changePartnerStatusSlice';
import businessPartnersReducer from '../redux/slices/businessPartnersSlice'; 
import partnersReducer from '../redux/slices/partnersSlice'; 
import totalPartnerReducer from '../redux/slices/totalPartnerSlice'; 
import totalPartnercmReducer from '../redux/slices/totalPartnerSlicebolt';

// Combine all slices
const appReducer = combineReducers({
  gst: gstReducer, 
  auth: authReducer, 
  otp: otpReducer, 
  pincode: pincodeReducer,
  member: memberReducer,
  businesslist: businessReducer,
  upload: uploadReducer,
  adminAuth: loginReducer, 
  businessData: businessDataReducer,
  memberVerify: memberVerifyReducer,
  partnerStatus: changePartnerStatusReducer,
  businessPartner: businessPartnersReducer, 
  partnerlist: partnersReducer, 
  totalPartner: totalPartnerReducer,
  totalcmpartner: totalPartnercmReducer
});

// Root reducer to reset state on logout
const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined; // Reset entire Redux state
  }
  return appReducer(state, action);
};

export default rootReducer;
